export const outboxDiagnosticsOwners = [
  { id: 'identity', permission: 'SystemDiagnostics.Read' },
  { id: 'config', permission: 'SystemDiagnostics.Read' },
  { id: 'project', permission: 'SystemDiagnostics.Read' },
  { id: 'workforce', permission: 'SystemDiagnostics.Read' },
  { id: 'reporting', permission: 'SystemDiagnostics.Read' },
  { id: 'document', permission: 'SystemDiagnostics.Read' },
  { id: 'workflow', permission: 'SystemDiagnostics.Read' },
  { id: 'chat', permission: 'SystemDiagnostics.Read' },
  { id: 'procurement', permission: 'SystemDiagnostics.Read' },
] as const
export type OutboxOwner = typeof outboxDiagnosticsOwners[number]['id']
export const outboxDiagnosticsPermissions = outboxDiagnosticsOwners.map(owner => owner.permission)
